import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

interface alertExpiryTimeProps {
  expiryTime: string;
}

const AlertExpiryTimer: React.FC<alertExpiryTimeProps> = (props) => {
  const { expiryTime } = props;

  const [timeLeft, setTimeLeft] = useState<string | null>();

  useEffect(() => {
    let timer: any;
    const calculateTimeLeft = () => {
      const now = dayjs();
      const expiration = dayjs(expiryTime);
      const diffInSeconds = expiration.diff(now, 'second');
      if (diffInSeconds <= 0) {
        setTimeLeft('00hrs 00mins 00sec');
        clearInterval(timer);
      } else {
        const hours = Math.floor(diffInSeconds / 3600)
          .toString()
          .padStart(2, '0');
        const minutes = Math.floor((diffInSeconds % 3600) / 60)
          .toString()
          .padStart(2, '0');
        const seconds = (diffInSeconds % 60).toString().padStart(2, '0');

        setTimeLeft(`${hours}hrs ${minutes}mins ${seconds}sec`);
      }
    };

    calculateTimeLeft();
    timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [expiryTime]);

  return (
    <div className="alert-expiry-timer" data-testid="alert-expiry-timer">
      <div>Event will expire in:</div>
      <span className="timer">{timeLeft}</span>
    </div>
  );
};

export default AlertExpiryTimer;
